export default {
  full_menu: 'Koko valikko',
  free: 'ILMAINEN',
};
